import { Layout } from 'antd';
import MenuContent from './MenuContent';
import Logo from './Logo';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';
import { SIDE_NAV_WIDTH } from 'constants/ThemeConstant';

const { Sider } = Layout;

export const SideNav = () => {
  const { theme, isNavCollapsed, setNavCollapsed } = useTheme();
  return (
    <Sider
      theme={theme}
      width={SIDE_NAV_WIDTH}
      collapsible
      collapsed={isNavCollapsed}
      onCollapse={(collapsed) => setNavCollapsed(collapsed)}
    >
      <Logo />
      <MenuContent />
    </Sider>
  );
};

export default SideNav;
